
export default class {
    constructor() {
        this.fixNav = ".js-fix-nav";
        this.init();
    }
		init() {
			const fixNavCont = document.querySelector(this.fixNav);
			window.onresize = paddingNavH;
			window.addEventListener('load', (event) => {
				paddingNavH();
			});

			function paddingNavH(){
				if (fixNavCont) {
					const fixNavH = fixNavCont.clientHeight;
					document.body.style.paddingBottom = fixNavH + 'px';
					document.querySelector('.js-drawer-inner').style.paddingBottom = fixNavH + 'px';
				}
			}
    }
}